// The admin copilot (LunaChatbot) is mounted by DashboardPageContainer. On
// desktop its trigger is the "Ask Luna" button of the top bar, which opens it
// through this window event (same pattern as the ⌘K palette).
export const OPEN_LUNA_CHAT_EVENT = 'hostea:open-luna-chat';

export const openLunaChat = () => {
  window.dispatchEvent(new Event(OPEN_LUNA_CHAT_EVENT));
};
